import { type FC, type JSXElementConstructor, useEffect } from 'react';
import { Route, Router, Switch } from 'wouter';
import { BASE } from '@/base/constants';
import { OpenAppDialog } from '@/base/OpenAppDialog';
import { useLocation } from '@/base/router';
import { initiateSentry, SentryProvider } from '@/base/sentry';
import { ErrorBoundary } from '@/base/sentry/ErrorBoundary';
import { UserbackProvider } from '@/base/userback';
import { I18nProvider } from '@/i18n';
import { NotificationProvider } from '@/notifications/NotificationProvider';
import { ToastProvider } from '@/shared/Toast';
import { SpotlightProvider } from '@/spotlight/SpotlightProvider';
import { SwrProvider } from '@/swr/utils';
import { ThemeProvider } from '@/theme/theme';

initiateSentry();

export const createBase = (workspace?: string) => {
  const ret = [BASE, workspace].filter((x) => !!x).join('/');
  return ret ? `/${ret}` : '';
};

export const ScrollToTop: FC = () => {
  const [loc] = useLocation();
  useEffect(() => {
    loc;
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [loc]);
  return null;
};

export const Workspace: FC<{
  base?: string;
  routes: Record<string, JSXElementConstructor<any>>;
}> = ({ base, routes }) => {
  return (
    <ToastProvider>
      <SwrProvider>
        <I18nProvider>
          <ThemeProvider>
            <UserbackProvider>
              <SentryProvider>
                <ErrorBoundary>
                  <NotificationProvider>
                    <SpotlightProvider>
                      <Router base={createBase(base)}>
                        <Switch>
                          {Object.entries(routes).map(([path, component]) => (
                            <Route
                              key={path}
                              path={path}
                              component={component}
                            />
                          ))}
                        </Switch>
                        <ScrollToTop />
                      </Router>
                    </SpotlightProvider>
                  </NotificationProvider>
                  <OpenAppDialog />
                </ErrorBoundary>
              </SentryProvider>
            </UserbackProvider>
          </ThemeProvider>
        </I18nProvider>
      </SwrProvider>
    </ToastProvider>
  );
};
